<div class="input-group m-0">
  <input
    type="text"
    class="form-control"
    [class.is-invalid]="showError"
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [attr.data-testid]="props.testId"
  />
  @if (props.submitText) {
    <button
      type="button"
      class="btn btn-colour-blue-600 text-nowrap"
      [disabled]="props.disabled"
      (click)="props.clickHandler(field)">
      {{ props.submitText }}
    </button>
  }
</div>

@if (props.linkText && !props.disabled) {
  <div class="row pt-3 pb-2">
    <div class="col-12">
      <a href="javascript:void(0)" class="text-small" (click)="props.setAddressType()">{{ props.linkText }}</a>
    </div>
  </div>
}
